import React from 'react';
import { Download, FileText, Printer } from 'lucide-react';
import { bookContent } from '../data/bookContent';
import { toast } from 'sonner';

export const DownloadPDF = () => {
  
  const generateFullPDF = () => {
    const printContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>${bookContent.title} - Complete E-Book</title>
        <style>
          @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500&family=Nunito:wght@300;400;500;600;700&family=Caveat:wght@400;500;600&display=swap');
          
          @page {
            size: A4;
            margin: 2.5cm 2cm;
          }
          
          * { box-sizing: border-box; margin: 0; padding: 0; }
          
          body {
            font-family: 'Nunito', sans-serif;
            color: #2D2030;
            line-height: 1.8;
            font-size: 11pt;
          }
          
          h1, h2, h3, h4 {
            font-family: 'Cormorant Garamond', serif;
            line-height: 1.3;
            color: #2D2030;
          }
          
          .cover-page {
            height: 100vh;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
            page-break-after: always;
            background: linear-gradient(180deg, #E6F0EE 0%, #FEFCFD 100%);
            padding: 40px;
          }
          
          .cover-page h1 {
            font-size: 48pt;
            color: #2D2030;
            margin-bottom: 16px;
            letter-spacing: -0.02em;
          }
          
          .cover-page .subtitle {
            font-size: 16pt;
            font-style: italic;
            color: #6B5B6E;
            margin-bottom: 40px;
          }
          
          .cover-page .tagline {
            font-size: 12pt;
            color: #7B1045;
            max-width: 400px;
            margin-bottom: 60px;
          }
          
          .cover-page .author {
            font-family: 'Caveat', cursive;
            font-size: 18pt;
            color: #D4AF37;
          }
          
          .toc-page {
            page-break-after: always;
            padding: 40px 0;
          }
          
          .toc-page h2 {
            font-size: 28pt;
            text-align: center;
            margin-bottom: 40px;
            color: #7B1045;
          }
          
          .toc-item {
            display: flex;
            justify-content: space-between;
            align-items: baseline;
            padding: 12px 0;
            border-bottom: 1px dotted #E5E5E5;
          }
          
          .toc-item .chapter-num {
            color: #D4AF37;
            font-weight: 600;
            margin-right: 12px;
          }
          
          .toc-item .chapter-title {
            font-family: 'Cormorant Garamond', serif;
            font-size: 14pt;
          }
          
          .intro-page {
            page-break-after: always;
            padding: 40px 0;
          }
          
          .intro-page h2 {
            font-size: 24pt;
            color: #7B1045;
            margin-bottom: 24px;
            text-align: center;
          }
          
          .intro-page p {
            margin-bottom: 16px;
            text-align: justify;
          }
          
          .chapter {
            page-break-before: always;
          }
          
          .chapter-header {
            text-align: center;
            padding: 60px 0 40px;
            border-bottom: 2px solid #7B1045;
            margin-bottom: 30px;
          }
          
          .chapter-header .chapter-num {
            font-size: 12pt;
            color: #D4AF37;
            text-transform: uppercase;
            letter-spacing: 3px;
            margin-bottom: 12px;
          }
          
          .chapter-header h2 {
            font-size: 32pt;
            margin-bottom: 8px;
          }
          
          .chapter-header .subtitle {
            font-size: 14pt;
            font-style: italic;
            color: #6B5B6E;
          }
          
          .scripture-box {
            background: #FBF5F7;
            border-left: 4px solid #D4AF37;
            padding: 24px 30px;
            margin: 30px 0;
            text-align: center;
          }
          
          .scripture-box p {
            font-family: 'Cormorant Garamond', serif;
            font-size: 14pt;
            font-style: italic;
            margin-bottom: 12px;
          }
          
          .scripture-box .reference {
            font-family: 'Nunito', sans-serif;
            font-size: 10pt;
            color: #D4AF37;
            font-style: normal;
            font-weight: 600;
          }
          
          .content-section {
            margin: 24px 0;
          }
          
          .content-section p {
            margin-bottom: 16px;
            text-align: justify;
          }
          
          .quote-box {
            border-left: 3px solid #7B1045;
            padding-left: 20px;
            margin: 30px 0;
            font-style: italic;
            color: #6B5B6E;
          }
          
          .affirmation-box {
            background: linear-gradient(135deg, #F3E5AB33, #F3E5AB11);
            border: 1px solid #D4AF3733;
            border-radius: 8px;
            padding: 24px;
            margin: 30px 0;
            text-align: center;
          }
          
          .affirmation-box .label {
            font-size: 10pt;
            color: #D4AF37;
            text-transform: uppercase;
            letter-spacing: 2px;
            margin-bottom: 12px;
          }
          
          .affirmation-box p {
            font-family: 'Caveat', cursive;
            font-size: 18pt;
            color: #2D2030;
          }
          
          .journal-section {
            margin: 40px 0;
            page-break-inside: avoid;
          }
          
          .journal-section h3 {
            font-size: 18pt;
            color: #7B1045;
            margin-bottom: 20px;
            padding-bottom: 8px;
            border-bottom: 1px solid #E5E5E5;
          }
          
          .journal-prompt {
            margin-bottom: 30px;
          }
          
          .journal-prompt .question {
            font-weight: 600;
            margin-bottom: 12px;
          }
          
          .journal-prompt .lines {
            border-bottom: 1px solid #E5E5E5;
            height: 24px;
            margin-bottom: 8px;
          }
          
          .prayer-box {
            background: linear-gradient(135deg, #D4A0B522, #7B104511);
            border-radius: 8px;
            padding: 30px;
            margin: 40px 0;
          }
          
          .prayer-box h3 {
            font-size: 18pt;
            color: #7B1045;
            margin-bottom: 16px;
          }
          
          .prayer-box p {
            margin-bottom: 12px;
          }
          
          .closing-page {
            page-break-before: always;
            padding: 60px 0;
            text-align: center;
          }
          
          .closing-page h2 {
            font-size: 28pt;
            color: #7B1045;
            margin-bottom: 30px;
          }
          
          .closing-page p {
            margin-bottom: 16px;
            max-width: 500px;
            margin-left: auto;
            margin-right: auto;
          }
          
          .closing-page .signature {
            font-family: 'Caveat', cursive;
            font-size: 18pt;
            color: #D4AF37;
            margin-top: 40px;
          }
          
          .footer-scripture {
            margin-top: 60px;
            padding-top: 30px;
            border-top: 1px solid #E5E5E5;
            text-align: center;
          }
          
          .footer-scripture p {
            font-family: 'Cormorant Garamond', serif;
            font-style: italic;
            font-size: 12pt;
          }
          
          .footer-scripture .ref {
            font-family: 'Nunito', sans-serif;
            font-size: 10pt;
            color: #D4AF37;
            margin-top: 8px;
          }
          
          @media print {
            .no-print { display: none; }
            body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          }
        </style>
      </head>
      <body>
        <!-- Cover Page -->
        <div class="cover-page">
          <h1>${bookContent.title}</h1>
          <p class="subtitle">${bookContent.subtitle}</p>
          <p class="tagline">A faith-based healing guide for all women breaking free from shame, guilt, and limiting beliefs after trauma</p>
          <p class="author">By Janelle McGowan-Charles</p>
          <p style="font-size: 12pt; color: #7B1045; margin-top: 20px;">Purpose Reclaimed Coaching</p>
          <p style="font-size: 10pt; color: #6B5B6E; margin-top: 40px;">© ${new Date().getFullYear()} Janelle McGowan-Charles, Purpose Reclaimed Coaching.<br>All rights reserved.</p>
        </div>
        
        <!-- Table of Contents -->
        <div class="toc-page">
          <h2>Contents</h2>
          ${bookContent.chapters.map((ch, idx) => `
            <div class="toc-item">
              <div>
                <span class="chapter-num">Chapter ${ch.id}</span>
                <span class="chapter-title">${ch.title}</span>
              </div>
            </div>
          `).join('')}
        </div>
        
        <!-- Introduction -->
        <div class="intro-page">
          <h2>A Letter to You</h2>
          ${bookContent.introduction.split('\n\n').map(p => `<p>${p}</p>`).join('')}
        </div>
        
        <!-- Chapters -->
        ${bookContent.chapters.map(chapter => `
          <div class="chapter">
            <div class="chapter-header">
              <div class="chapter-num">Chapter ${chapter.id}</div>
              <h2>${chapter.title}</h2>
              <p class="subtitle">${chapter.subtitle}</p>
            </div>
            
            <div class="scripture-box">
              <p>"${chapter.scripture.text}"</p>
              <span class="reference">— ${chapter.scripture.reference}</span>
            </div>
            
            <div class="content-section">
              ${chapter.content.split('\n\n').map(p => `<p>${p}</p>`).join('')}
            </div>
            
            <div class="quote-box">
              <p>"${chapter.quote}"</p>
            </div>
            
            <div class="affirmation-box">
              <div class="label">Affirmation</div>
              <p>"${chapter.affirmation}"</p>
            </div>
            
            <div class="journal-section">
              <h3>Reflection Questions</h3>
              ${chapter.journalQuestions.map((q, idx) => `
                <div class="journal-prompt">
                  <p class="question">${idx + 1}. ${q}</p>
                  <div class="lines"></div>
                  <div class="lines"></div>
                  <div class="lines"></div>
                  <div class="lines"></div>
                </div>
              `).join('')}
            </div>
            
            <div class="prayer-box">
              <h3>Closing Prayer</h3>
              ${chapter.prayer.split('\n\n').map(p => `<p>${p}</p>`).join('')}
            </div>
            
            ${chapter.closingBenediction ? `
              <div class="closing-page">
                <h2>A Final Word</h2>
                ${chapter.closingBenediction.split('\n\n').map(p => `<p>${p}</p>`).join('')}
              </div>
            ` : ''}
          </div>
        `).join('')}
        
        <!-- Final Page -->
        <div class="closing-page">
          <div class="footer-scripture">
            <p>"He heals the brokenhearted and binds up their wounds."</p>
            <p class="ref">— Psalm 147:3</p>
          </div>
          
          <p class="signature" style="margin-top: 60px;">Your breakthrough has begun.</p>
          
          <div style="margin-top: 80px; padding-top: 30px; border-top: 1px solid #E5E5E5; text-align: center;">
            <p style="font-size: 12pt; color: #2D2030;">By Janelle McGowan-Charles</p>
            <p style="font-size: 11pt; color: #7B1045;">Purpose Reclaimed Coaching</p>
            <p style="font-size: 9pt; color: #6B5B6E; margin-top: 20px;">© ${new Date().getFullYear()} Janelle McGowan-Charles, Purpose Reclaimed Coaching.<br>All rights reserved. No part of this publication may be reproduced, distributed, or transmitted without prior written permission.</p>
          </div>
        </div>
      </body>
      </html>
    `;

    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.focus();
    
    setTimeout(() => {
      printWindow.print();
    }, 1000);

    toast.success('PDF ready!', {
      description: 'Choose "Save as PDF" in the print dialog'
    });
  };

  return (
    <button
      onClick={generateFullPDF}
      data-testid="download-full-pdf-btn"
      className="inline-flex items-center gap-2 px-6 py-3 bg-sage text-white rounded-full font-medium hover:bg-sage-dark transition-all shadow-lg"
    >
      <Download className="w-5 h-5" />
      Download Complete PDF
    </button>
  );
};
